import { Component, OnInit, Input } from '@angular/core';
import { Subscription } from "rxjs/Subscription";
import { NotificationsService } from "angular2-notifications";

import { GUID, Param } from "app/brightserve/brightserve.module";
import { IncidentFinding, SlimScrollOptions } from "app/shared/shared.module";
import { AddonService } from "app/add-ons/addon.service";

@Component({
  selector: 'app-addon-incident-findings',
  templateUrl: './addon-incident-findings.component.html',
  styleUrls: ['./addon-incident-findings.component.css']
})
export class AddonIncidentFindingsComponent implements OnInit {
    Findings: IncidentFinding[];
    IncidentAdd: boolean = false;
    IncidentFindingsText: string;

    GetIncidentFindingSubscription: Subscription;
    AddIncidentFindingSubscription: Subscription;

    SlimScrollOptions = SlimScrollOptions;

    @Input() IncidentId: GUID;
    @Input() EnableAdd: boolean = false;

    constructor(private addonService: AddonService, private _notification: NotificationsService) { }


    ngOnInit() {
        this.Reset();
    }

    ngOnChanges() {
        this.GetIncidentFindings();
    }

    ngOnDestroy() {
        if (this.GetIncidentFindingSubscription != null)
            this.GetIncidentFindingSubscription.unsubscribe();
        if (this.AddIncidentFindingSubscription != null)
            this.AddIncidentFindingSubscription.unsubscribe();
    }

    OpenAdd() {
        this.IncidentAdd = true;
    }

    GetIncidentFindings() {
        if (this.IncidentId) {
            this.GetIncidentFindingSubscription = this.addonService.GetIncidentFindings(this.IncidentId).subscribe(
                findings => {
                    this.Findings = findings;
                }, err => {
                    this._notification.error("Data Error", "Incident findings data for this incident could not be obtained.");
                }
            );
        }
    };

    AddIncidentFinding() {
        var finding = IncidentFinding.BlankIncidentFinding();
        finding.Text = this.IncidentFindingsText
        finding.Status = new Param({ Entity: "Annotation", Field: "Status", Value: "New" });
        this.AddIncidentFindingSubscription = this.addonService.AddIncidentFindingToIncident(this.IncidentId, finding).subscribe(
            finding => {
                this.Reset();
                this.GetIncidentFindings();
                this._notification.success("Finding Saved", "Incident finding was added to this incident successfully.");
            }, err => {
                this._notification.error("Finding not Saved", "Incident finding was not added to this incident successfully.");
            }
        );
    }


    Reset() {
        this.IncidentAdd = false;
        this.IncidentFindingsText = "";
    }

}



// WEBPACK FOOTER //
// ./src/app/add-ons/incident-findings/addon-incident-findings.component.ts